import { userApi } from '@/features/user/userApi';

/**
 * After an admin change to a user, refetch the CRM's cached copies of users (userApi), so
 * the CRM shows the change without a reload: getUserDetails / getUserById ('USER', which
 * getUserDetails tags by email, so all of them), getUsersByIds ('USERS'), and the broker
 * group user lists behind the owner pickers and filters ('BROKER_GROUP_USERS').
 */
export const invalidateCrmUsers = (dispatch) =>
	dispatch(userApi.util.invalidateTags(['USER', 'USERS', 'BROKER_GROUP_USERS']));

/**
 * After an admin change to a broker group, refetch the CRM's cached copies of it (userApi
 * 'BROKER_GROUP' for that id), and the users whose details include their broker group
 * ('USER').
 */
export const invalidateCrmBrokerGroup = (dispatch, brokerGroupId) =>
	dispatch(userApi.util.invalidateTags([{ type: 'BROKER_GROUP', id: brokerGroupId }, 'USER']));

/**
 * An RTK Query onQueryStarted that runs invalidate(dispatch, arg) once the mutation
 * succeeds (a failed one changed nothing).
 */
export const afterSuccess = (invalidate) => async (arg, { dispatch, queryFulfilled }) => {
	try {
		await queryFulfilled;
		invalidate(dispatch, arg);
	} catch {
		// The mutation reports its own error
	}
};
